import { Controller } from "react-hook-form";
import { ModalInput } from "../../Atoms/InputModal";
import { DatePickerCustom } from "../../Atoms/DatePicker";
import clsx from "clsx";
import Styles from "./index.module.scss";
import { Button } from "react-bootstrap";
import { SelectModal } from "../../Atoms/SelectModal";
import { VOUCHER_TYPES } from "../../../Constants/voucher";
export const CreateVoucherForm = ({
  handleSetMonth,
  handleSetYear,
  handleSubmit,
  control,
}) => {
  return (
    <div className={clsx(Styles.container)}>
      <form onSubmit={handleSubmit}>
        <DatePickerCustom
          variant="inline"
          openTo="month"
          views={["year", "month"]}
          label="Tháng áp dụng (Không áp dụng với GLOBAL) "
          handleSetMonth={handleSetMonth}
          handleSetYear={handleSetYear}
        />
        <Controller
          name="quantity"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ModalInput
              label="Số lượng (Không áp dụng với GLOBAL)"
              id="quantity"
              value={field.value}
              onChange={field.onChange}
              error={error}
            />
          )}
        />
        <Controller
          name="min_pay"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ModalInput
              label="Mức thêm tối thiểu"
              id="min_pay"
              value={field.value}
              onChange={field.onChange}
              error={error}
            />
          )}
        />

        <Controller
          name="voucher_type"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <SelectModal
              label="Loại"
              id="voucher_type"
              onChange={field.onChange}
              error={error}
              options={VOUCHER_TYPES}
              value={field.value}
            />
          )}
        />

        <Controller
          name="ref_rate"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <ModalInput
              label="Thưởng giới thiệu (Chỉ áp dụng với GLOBAL)"
              id="ref_rate"
              value={field.value}
              onChange={field.onChange}
              error={error}
            />
          )}
        />

        <div className={clsx(Styles.limitWrap)}>
          <div className={clsx(Styles.limit)}>
            <Controller
              name={`limit1`}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <ModalInput
                  label={`Hạn mức 1`}
                  id={`limit1`}
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                />
              )}
            />
          </div>
          <div className={clsx(Styles.rate)}>
            <Controller
              name={`ex_rate1`}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <ModalInput
                  label={`Hệ số 1`}
                  id={`ex_rate1`}
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                />
              )}
            />
          </div>
        </div>
        <div className={clsx(Styles.limitWrap)}>
          <div className={clsx(Styles.limit)}>
            <Controller
              name={`limit2`}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <ModalInput
                  label={`Hạn mức 2`}
                  id={`limit2`}
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                />
              )}
            />
          </div>
          <div className={clsx(Styles.rate)}>
            <Controller
              name={`ex_rate2`}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <ModalInput
                  label={`Hệ số 2`}
                  id={`ex_rate2`}
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                />
              )}
            />
          </div>
        </div>
        <div className={clsx(Styles.action)}>
          <p>* Mức thêm tối thiểu, hạn mức (x 1.000.000)</p>

          <Button
            variant="success"
            className={clsx(Styles.button)}
            type="submit"
          >
            Cập nhật
          </Button>
        </div>
      </form>
    </div>
  );
};
